// extracted by mini-css-extract-plugin
module.exports = {"leftArea":"TimelineTopMenuArea_leftArea__KNvmO","navBtn":"TimelineTopMenuArea_navBtn__vP0fB"};